import { render, staticRenderFns } from "./TournamentAwards.vue?vue&type=template&id=653780f2&scoped=true"
import script from "./TournamentAwards.vue?vue&type=script&lang=js"
export * from "./TournamentAwards.vue?vue&type=script&lang=js"
import style0 from "./TournamentAwards.vue?vue&type=style&index=0&id=653780f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653780f2",
  null
  
)

export default component.exports